import React, { useState } from "react";

function ConstructionFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How does your construction debris removal service work?",
      content: `
Our process is simple and hassle-free! Schedule your removal at a time that works for you, and our team will arrive with dump trucks and the right equipment to handle all the heavy lifting. Get a free estimate based on the space your materials take up on our truck and the type of construction debris being removed. We accept cash, check, debit, credit, and Zelle for your convenience. Plus, we do our best to recycle as much as possible to minimize waste and promote eco-friendly disposal.
      `,
    },
    {
      title: "What areas do you serve?",
      content: `
       We proudly provide construction debris removal services in the following areas:

Campbell,Los Altos,Fremont,Palo Alto,Saratoga,East Palo Alto,Cupertino,Los Gatos,Mountain View,San Jose,Milpitas,Newark,Santa Clara,Sunnyvale
      `,
    },
    {
      title:
        "What items do you remove during a construction debris removal project?",
      content: `
       We remove a wide range of materials, including:Concrete, asphalt, and bricks,Wood, drywall, and insulation,Scrap metal and roofing materials,General construction debris and renovation waste
      `,
    },
    {
      title: "Do you offer eco-friendly disposal options?",
      content: `
         Yes! We prioritize eco-friendly disposal and recycle materials like concrete, metal, and wood at licensed recycling centers to reduce waste.
        `,
    },
    {
      title: "How much does construction debris removal cost?",
      content: `
         The total cost depends on factors like the amount of debris (measured in cubic yards), type of materials, and location. We provide a free estimate after assessing your project.
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ConstructionFAQs;
